import React from "react";
import StopChipList from "../StopChipList";
import StopProperties from "../StopProperties";
import RadioGroupComponent from "./RadioGroupComponent";
import DestinationRouteList from "./DestinationRouteList";
import MergeStopsActions from "./MergeStopsActions";
import { postData } from "../../../../../../api/componentAPIs";
import {
  MERGE_TYPES,
  getDefaultMergePickupStopInfo,
  getShipperFieldError,
  getShipperPickupWindowsDetail,
  getShipperAddressList,
  getShipperInfoList,
  getDestinationRouteList,
  getListByKey,
  getUniqueLabelValue,
} from "../utills";
import { inject, observer } from "mobx-react";
import { withSnackbar } from "notistack";

@inject("IBPlanningStore")
@observer
class PickupStopMergeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mergeStopInProgress: false,
      mergeStopInfo: getDefaultMergePickupStopInfo(),
      errorInfo: {},
      shippers: [],
      pickupWindowList: [],
    };
  }

  componentDidMount() {
    this.initializeMergeStopDetails();
  }

  initializeMergeStopDetails = () => {
    const shipperIds = [
      ...new Set(this.props.selectedStops.map((stop) => stop.shipperCode)),
    ];
    this.destinationRouteList = getDestinationRouteList(
      this.props.selectedStops
    );
    this.getCustomerData(shipperIds);
    const { selectedStops } = this.props;
    this.shipperNameList = getListByKey(selectedStops, "shipperName");
    this.addressList = getShipperAddressList(selectedStops);
    this.shipperInfoList = getShipperInfoList(selectedStops);

    this.setState({
      mergeStopInfo: {
        mergedRmaxShipperCode:
          this.shipperInfoList.length === 1
            ? this.shipperInfoList[0].value.toString()
            : null,
        shipperName:
          this.shipperNameList.length === 1
            ? this.shipperNameList[0].value.toString()
            : null,
        rmaxShipperCodeForAddress:
          this.addressList.length === 1
            ? this.addressList[0].value.toString()
            : null,
        rmaxShipperCodeForPickupWindow: null,
        duplicateRmaxShipperCode: null,
        destinationRouteName: null,
      },
    });
  };

  getCustomerData = (customerCodes) => {
    this.props.fetchCustomerData(customerCodes).then((response) => {
      if (response && Math.trunc(response.status / 100) === 2) {
        this.setState(
          {
            shippers: response?.data ?? [],
          },
          this.updateMergeStopList
        );
      }
    });
  };

  updateMergeStopList = () => {
    const pickupWindowList = this.getShipperWindowList();
    this.setState((prevState) => ({
      pickupWindowList,
      mergeStopInfo: {
        ...prevState.mergeStopInfo,
        rmaxShipperCodeForPickupWindow:
          pickupWindowList.length === 1
            ? pickupWindowList[0].value.toString()
            : null,
      },
    }));
  };

  getFieldError = (field, value) => {
    const { pickupWindowList } = this.state;
    return getShipperFieldError({
      field,
      value,
      pickupWindowList,
      destinationRouteList: this.destinationRouteList,
    });
  };

  getRequestData = (mergeStopInfo) => {
    const requestData = mergeStopInfo;
    requestData.terminalId = this.props.userData.userProfile.terminal.id;
    requestData.scenarioId = this.props.userData.userProfile.scenarioID;
    const duplicateShipper =
      this.props.selectedStops.filter(
        (stop) => stop.rmaxShipperCode?.toLowerCase() !== requestData.mergedRmaxShipperCode?.toLowerCase()
      ) || [];
    requestData.duplicateRmaxShipperCode = duplicateShipper.map(
      (customer) => customer.rmaxShipperCode
    );
    if (requestData.destinationRouteName === null) {
      requestData.destinationRouteName = this.destinationRouteList[0].value;
    }
    return requestData;
  };

  mergeShippers = () => {
    const errorInfo = this.getErrorInfo();
    const fieldError = Object.values(errorInfo).filter((value) => value).length;
    this.setState({ mergeStopInProgress: !fieldError, errorInfo });
    if (fieldError) {
      return;
    }
    const requestData = this.getRequestData(this.state.mergeStopInfo);
    postData("MergeShippers", requestData).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.handleSuccess(requestData);
          return;
        }
        this.handleError(requestData);
      },
      (error) => {
        this.handleError(requestData);
      }
    );
  };

  handleSuccess = (requestData) => {
    if (this.props.mergeType === MERGE_TYPES.Customers) {
      this.props.onMergeCompleted();
    }
    this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [
      false,
      this.props.IBPlanningStore.selectedRouteNameList,
    ]);
    this.setState({ mergeStopInProgress: false });
    this.props.enqueueSnackbar("Stops merged successfully.", {
      variant: "success",
    });
    this.props.trackMergeActions("PickupMergeFailure", requestData);
    this.props.onClose();
  };

  handleError = (requestData) => {
    this.props.enqueueSnackbar(
      `An error occurred while merging stops. Please try again later.`,
      {
        variant: "error",
      }
    );
    this.props.trackMergeActions("PickupMergeFailure", requestData);
    this.setState({ mergeStopInProgress: false });
  };

  handleSelectUpdate = (name) => (event) => {
    const value = event.value;
    this.setState((state) => ({
      mergeStopInfo: {
        ...state.mergeStopInfo,
        [name]: value,
      },
      errorInfo: {
        ...state.errorInfo,
        [name]: this.getFieldError(name, value),
      },
    }));
  };

  handleUpdate = (name) => (event) => {
    const value = event.target.value;
    this.setState((state) => ({
      mergeStopInfo: {
        ...state.mergeStopInfo,
        [name]: value,
      },
      errorInfo: {
        ...state.errorInfo,
        [name]: this.getFieldError(name, value),
      },
    }));
  };

  getShipperWindowList = () => {
    return getUniqueLabelValue(
      this.props.selectedStops.map((stop) => {
        return getShipperPickupWindowsDetail(this.state.shippers, stop);
      })
    );
  };

  getErrorInfo = () => {
    const errorInfo = {};
    Object.keys(this.state.mergeStopInfo).forEach((fieldName) => {
      errorInfo[fieldName] = this.getFieldError(
        fieldName,
        this.state.mergeStopInfo[fieldName]
      );
    });
    return errorInfo;
  };

  render() {
    const { classes, selectedStops, mergeType } = this.props;
    const { errorInfo, mergeStopInfo, pickupWindowList } = this.state;
    return (
      <div className={classes.mergeContainer}>
        <div className={`${classes.main} customScroll`}>
          <div className={classes.group}>
            <div>Selected Stops</div>
            <StopChipList customerStops={selectedStops} isPickupStopMergeFlow />
            {mergeType === MERGE_TYPES.Stops && (
              <StopProperties selectedStops={selectedStops} />
            )}
          </div>
          <RadioGroupComponent
            name="shipperName"
            value={mergeStopInfo.shipperName}
            options={this.shipperNameList}
            onChange={this.handleUpdate("shipperName")}
            label="Shipper Name"
            errorInfo={errorInfo}
          />
          <RadioGroupComponent
            name="rmaxShipperCodeForAddress"
            value={mergeStopInfo.rmaxShipperCodeForAddress}
            options={this.addressList}
            onChange={this.handleUpdate("rmaxShipperCodeForAddress")}
            label="Address"
            errorInfo={errorInfo}
          />
          <RadioGroupComponent
            name="mergedRmaxShipperCode"
            value={mergeStopInfo.mergedRmaxShipperCode}
            options={this.shipperInfoList}
            onChange={this.handleUpdate("mergedRmaxShipperCode")}
            label="Shipper #"
            errorInfo={errorInfo}
          />
          {this.destinationRouteList?.length > 1 && (
            <DestinationRouteList
              options={this.destinationRouteList}
              onChange={this.handleSelectUpdate("destinationRouteName")}
              value={mergeStopInfo.destinationRouteName}
              errorInfo={errorInfo}
              classes={classes}
            />
          )}
          {pickupWindowList.length > 0 && (
            <RadioGroupComponent
              name="rmaxShipperCodeForPickupWindow"
              value={mergeStopInfo.rmaxShipperCodeForPickupWindow}
              options={pickupWindowList}
              onChange={this.handleUpdate("rmaxShipperCodeForPickupWindow")}
              label="Pickup Window"
              errorInfo={errorInfo}
            />
          )}
        </div>
        <MergeStopsActions
          mergeStopInProgress={this.state.mergeStopInProgress}
          onClose={this.props.onClose}
          onMergeClick={this.mergeShippers}
          classes={classes}
        />
      </div>
    );
  }
}

export default withSnackbar(PickupStopMergeForm);
